<template>
  <div>
    <History caption="History Check In By Course" icon="cil-clock"/>
  </div>
</template>

<script>


import {mapGetters} from 'vuex'
import History from "@/projects/views/E-Port/checkin/components/Historys";
export default {
  name: 'index',
  components: {History},
  props:{
    caption:{
      type: String,
      default: ""
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      mapping : {
        type : "",
        item : {}
      },

      dialog:true,
    }


  },

  mounted () {
  },

  created () {
    this.onInit()

  },
  beforeDestroy () {

  },

  methods: {
    onInit(){
    },
  },



  computed:{
    ...mapGetters({
      objsLang : "setting/lang",
    }),
  },

  watch: {

  }

}
</script>
<style >


</style>
